import React from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";

const ModalIFCLookupDetail = () => {
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const {show, ifcData} = useSelector(state => state.modal.ifcDetail);

    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_IFC_LOOKUP_HIDE});

    const renderModal = () => {
        if (show) {
            return <div ref={ref} className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header p-3">
                        <h5 className="modal-title h4 mb-0">{ifcData.description}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>

                    <div className="p-4">
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <p className="text-sm font-medium text-muted mb-1">Item Number</p>
                                <p className="text-lg font-weight-bold">{ifcData.itemNumber}</p>
                            </div>
                            <div className="col-md-4">
                                <p className="text-sm font-medium text-muted mb-1">Day/Overnight</p>
                                <p className="text-lg font-weight-bold">{ifcData.dayOrOvernight}</p>
                            </div>
                            <div className="col-md-4">
                                <p className="text-sm font-medium text-muted mb-1">Admission Type</p>
                                <p className="text-lg font-weight-bold">{ifcData.admissionType}</p>
                            </div>
                        </div>

                        <h5 className="text-lg">DRG Codes</h5>
                        <div className="row mb-4">
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted mb-1">MPL/AHM</p>
                                <p className="text-lg">{ifcData.mplAhmDrg}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted mb-1">AHSA</p>
                                <p className="text-lg">{ifcData.ahsaDrg}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted mb-1">BUPA</p>
                                <p className="text-lg">{ifcData.bupaDrg}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted  mb-1">PUBLIC</p>
                                <p className="text-lg">{ifcData.publicDrg}</p>
                            </div>
                        </div>

                        <h5 className="text-lg">Additional Information</h5>
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <p className="text-sm font-medium text-muted  mb-1">Pre-admission Checks</p>
                                <p className="text-lg">{ifcData.preAdmissionChecks || 'None'}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="text-sm font-medium text-muted  mb-1">Prosthesis Code</p>
                                <p className="text-lg">{ifcData.prosthesisCode || 'None'}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="text-sm font-medium text-muted  mb-1">Estimated Prosthesis Revenue</p>
                                <p className="text-lg">{ifcData.estimatedProsthesisRevenue || 'None'}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="text-sm font-medium text-muted  mb-1">ALOS</p>
                                <p className="text-lg">{ifcData.alos || 'None'}</p>
                            </div>
                        </div>

                        <h5 className="text-lg">Other Codes</h5>
                        <div className="row">
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted  mb-1">DVA</p>
                                <p className="text-lg">{ifcData.dva || 'None'}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted  mb-1">HCF</p>
                                <p className="text-lg">{ifcData.hcf || 'None'}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted  mb-1">NIB</p>
                                <p className="text-lg">{ifcData.nib || 'None'}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="text-sm font-medium text-muted  mb-1">ARHG</p>
                                <p className="text-lg">{ifcData.arhg || 'None'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }

    return (
        <div className={`modal modal-ifc-lookup-detail fade ${show ? 'show' : ''}`} id="modalIFCLookupDetail" tabIndex="-1" role="dialog" style={{display: "block", paddingRight: "11px"}}>
            {renderModal()}
        </div>
    )
}

export default ModalIFCLookupDetail;